import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import Select from "react-select";
import { roles } from "../../config/config";
import * as apiCalendario from "../../api/calendario";
import * as apiMedici from "../../api/medici";
import AsyncMediciSelect from "../../pages/Campioni/components/AsyncMediciSelect";

export const AddEvento = ({ show, setShow, user, doUpdate, initialEvent, dateClick }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [medici, setMedici] = useState([]);

  // const updateFromServer = () => {
  //   setLoading(true);
  //   apiMedici
  //     .getAll(user.authToken)
  //     .then((data) => {
  //       setMedici(
  //         data.map((medico) => ({
  //           value: medico.id,
  //           label: medico.fullname,
  //           specializzazione: medico.specializzazione,
  //           address: medico.address,
  //         }))
  //       );
  //     })
  //     .catch((err) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Errore nel caricamento dei medici",
  //         confirmButtonColor: "#3699ff",
  //         confirmButtonText: "Chiudi",
  //       });
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  useEffect(() => {
    //pdateFromServer();
  }, []);

  const eventSchema = Yup.object({
    title: Yup.string("Inserire un titolo valido")
      .required("Inserire un titolo valido")
      .min(3, "Minimo 3 caratteri")
      .max(100, "Massimo 100 caratteri"),
    description: Yup.string("Inserire una descrizione valida")
      .notRequired()
      .min(3, "Minimo 3 caratteri")
      .max(255, "Massimo 500 caratteri"),
    location: Yup.string("Inserire un indirizzo valido")
      .notRequired()
      .min(3, "Minimo 3 caratteri")
      .max(255, "Massimo 255 caratteri"),
    place: Yup.string("Inserire un luogo valido")
      .notRequired()
      .min(3, "Minimo 3 caratteri")
      .max(255, "Massimo 255 caratteri"),
    startDate: Yup.date("Inserire una data valida").required(
      "Inserire una data valida"
    ),
    allDay: Yup.boolean(),
    endDate: Yup.date("Inserire una data valida").test(
      "required when",
      "Inserire una data di fine evento",
      function(value) {
        let allDay = this.options.parent.allDay;
        let startDate = this.options.parent.startDate;
        return !!value || (allDay && !!startDate);
      }
    ),
    startTime: Yup.string().test(
      "required when",
      "Quando è impostato un orario di fine evento, deve essere impostato l'orario di inizio evento",
      function(value) {
        let endTime = this.options.parent.endTime;
        let allDay = this.options.parent.allDay;
        return !(endTime && !value && !allDay);
      }
    ),
    endTime: Yup.string()
      .test(
        "endTime required when",
        "Quando l'orario di inizio è impostato, deve essere impostato un orario di fine evento",
        function(value) {
          let correct = true;
          let allDay = this.options.parent.allDay;
          let startTime = this.options.parent.startTime;
          if (startTime && !allDay && !value) {
            correct = false;
          }
          return correct;
        }
      )
      .test(
        "startDate same of endDate",
        "Quando la data di inizio e fine evento coincidono, l'orario di fine evento non può essere precedente a quello di inizo evento",
        function(value) {
          let startTime = moment(this.options.parent.startTime, "HH:mm");
          let startDate = this.options.parent.startDate;
          let endDate = this.options.parent.endDate;
          let endTime = moment(value, "HH:mm");
          let allDay = this.options.parent.allDay;
          return !(
            startTime &&
            moment(startDate).isSame(endDate) &&
            moment(startTime).isAfter(endTime) &&
            !allDay
          );
        }
      ),
  });

  const onCheck = () => {
    formik.setFieldValue("allDay", !formik.values.allDay);
    if (!formik.values.allDay) {
      formik.setFieldValue("startTime", "");
      formik.setFieldValue("endTime", "");
    }
  };

  const info = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Rendi l'evento visibile ad altri agenti
      {parseInt(user.idRole) === roles.admin || parseInt(user.idRole) === roles.gestore ? " oppure a tutti" : null}
    </Tooltip>
  );

  const infoColor = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Seleziona con quale colore visualizzerai l'evento sul calendario
    </Tooltip>
  );

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  const parseInitialValues = (evt) => {
    if (!evt) {
      return {
        title: "",
        description: "",
        location: "",
        place: "",
        allDay: false,
        startDate: dateClick ? moment(dateClick).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        startTime: "",
        endDate: dateClick ? moment(dateClick).format("YYYY-MM-DD") : "",
        endTime: "",
        backgroundColor: "#126f8b",
        visible: false,
        department: 0,
        idMedico: 0,
      };
    }
    const isAllDay = parseInt(evt.allDay) === 1;
    const startSplit = String(evt.startDate).split("T");
    const endSplit = String(evt.endDate).split("T");
    const startDate = startSplit[0];
    const startTime = !isAllDay && startSplit[1] ? startSplit[1] : "";
    const endDate = endSplit[0] || startDate;
    const endTime = !isAllDay && endSplit[1] ? endSplit[1] : "";
    const visible = evt.department !== -1;
    const department = visible ? evt.department : 0;
    return {
      title: evt.title || "",
      description: evt.description || "",
      location: evt.location || "",
      place: evt.place || "",
      allDay: isAllDay,
      startDate,
      startTime,
      endDate,
      endTime,
      backgroundColor: evt.color || "#126f8b",
      visible,
      department,
      idMedico: (evt.medico && evt.medico.id) ? evt.medico.id : 0,
    };
  };

  const formik = useFormik({
    initialValues: parseInitialValues(initialEvent),
    validationSchema: eventSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      let data = {
        title: values.title,
        description: values.description,
        location: values.location,
        place: values.place,
        allDay: values.allDay ? "1" : "0",
        startDate: values.startDate,
        startTime: values.startTime,
        endDate: !!values.endDate ? values.endDate : values.startDate,
        endTime: values.endTime,
        backgroundColor: values.backgroundColor,
        department: values.visible ? values.department : -1,
        idMedico: values.idMedico,
        idEvento: initialEvent && initialEvent.id ? initialEvent.id : 0,
      };
      setLoading(true);
      setError(false);
      setErrorMessage("");
      apiCalendario
        .addEvento({ accessToken: user.authToken, ...data })
        .then(() => {
          setShow(false);
          doUpdate();
        })
        .catch((err) => {
          setError(true);
          setErrorMessage(
            "Errore non previsto, riprovare ad inserire l'evento."
          );
          console.log(err);
        })
        .finally(() => setLoading(false));
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header className="border-0 py-4">{initialEvent ? "Modifica evento" : "Aggiungi evento"}</Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group className="col-12">
              <Form.Label htmlFor="title">Titolo evento</Form.Label>
              <Form.Control
                type="text"
                id="title"
                name="title"
                placeholder="Titolo..."
                className={getInputClasses("title")}
                {...formik.getFieldProps("title")}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.title}</div>
                </div>
              ) : null}
            </Form.Group>
            <Form.Group className="col-xxl-12 col-lg-12 col-sm-12">
              <Form.Label htmlFor="location">Indirizzo</Form.Label>
              <Form.Control
                as="textarea"
                id="location"
                name="location"
                placeholder="Indirizzo..."
                className={getInputClasses("location")}
                {...formik.getFieldProps("location")}
              />
              {formik.touched.location && formik.errors.location ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.location}</div>
                </div>
              ) : null}
            </Form.Group>

            <Form.Group className="col-xxl-12 col-lg-12 col-sm-12">
              <Form.Label htmlFor="place">Luogo</Form.Label>
              <Form.Control
                type="text"
                id="place"
                name="place"
                placeholder="Hotel del Mare..."
                className={getInputClasses("place")}
                {...formik.getFieldProps("place")}
              />
              {formik.touched.place && formik.errors.place ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.place}</div>
                </div>
              ) : null}
            </Form.Group>

            <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
              <Form.Label></Form.Label>
              <label className="checkbox mt-2">
                <input
                  type="checkbox"
                  color="primary"
                  className="checkbox-inline"
                  name="allDay"
                  checked={formik.values.allDay}
                  onChange={onCheck}
                />
                <span style={{ marginRight: "5px" }}></span>
                {formik.values.allDay ? "Tutto il giorno" : "Tutto il giorno" }
              </label>
            </Form.Group>
            <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
              <Form.Label htmlFor="backgroundColor">
                Seleziona colore evento
                <OverlayTrigger placement="top" overlay={infoColor}>
                  <i className="ml-2 far fa-question-circle fa-sm"></i>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                id="backgroundColor"
                type="color"
                name="backgroundColor"
                className="col-4 ml-3"
                value={formik.values.backgroundColor}
                onChange={formik.handleChange}
              />
            </Form.Group>
            <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
              <Form.Label htmlFor="startDate">Data evento</Form.Label>
              <Form.Control
                id="startDate"
                type="date"
                name="startDate"
                value={moment(formik.values.startDate).format("YYYY-MM-DD")}
                className={getInputClasses("startDate")}
                {...formik.getFieldProps("startDate")}
              />
              {formik.touched.startDate && formik.errors.startDate ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.startDate}</div>
                </div>
              ) : null}
            </Form.Group>
            {!formik.values.allDay ? (
              <>
                <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
                  <Form.Label htmlFor="startTime">Ora evento</Form.Label>
                  <Form.Control
                    id="startTime"
                    type="time"
                    name="startTime"
                    disabled={formik.values.allDay}
                    value={formik.values.allDay ? "" : formik.values.startTime}
                    className={getInputClasses("startTime")}
                    {...formik.getFieldProps("startTime")}
                  />
                  {formik.touched.startTime && formik.errors.startTime ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.startTime}
                      </div>
                    </div>
                  ) : null}
                </Form.Group>
              </>
            ) : null}
            <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
              <Form.Label htmlFor="endDate">Data fine evento</Form.Label>
              <Form.Control
                id="endDate"
                type="date"
                name="endDate"
                min={moment(formik.values.startDate).format("YYYY-MM-DD")}
                value={moment(formik.values.endDate).format("YYYY-MM-DD")}
                className={getInputClasses("endDate")}
                {...formik.getFieldProps("endDate")}
              />
              {formik.touched.endDate && formik.errors.endDate ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.endDate}</div>
                </div>
              ) : null}
            </Form.Group>
            {!formik.values.allDay ? (
              <>
                <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
                  <Form.Label htmlFor="endTime">Ora fine evento</Form.Label>
                  <Form.Control
                    id="endTime"
                    type="time"
                    name="endTime"
                    disabled={formik.values.allDay}
                    value={formik.values.allDay ? "" : formik.values.endTime}
                    className={getInputClasses("endTime")}
                    {...formik.getFieldProps("endTime")}
                  />
                  {formik.touched.endTime && formik.errors.endTime ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.endTime}
                      </div>
                    </div>
                  ) : null}
                </Form.Group>{" "}
              </>
            ) : null}
            {parseInt(user.idRole) === roles.admin || parseInt(user.idRole) === roles.gestore ? (
              <Form.Group className="col-xxl-6 col-lg-6 col-sm-12">
                <Form.Label>
                  Aggiungi partecipanti
                  <OverlayTrigger placement="top" overlay={info}>
                    <i className="ml-2 far fa-question-circle fa-sm"></i>
                  </OverlayTrigger>
                </Form.Label>
                <label className="checkbox mt-2">
                  <input
                    type="checkbox"
                    color="primary"
                    className="checkbox-inline"
                    {...formik.getFieldProps("visible")}
                    checked={formik.values.visible}
                  />
                  <span style={{ marginRight: "5px" }}></span>
                  {formik.values.visible ? "Si" : "No"}
                </label>
              </Form.Group>
            ) : null}
            {formik.values.visible ? (
              <Form.Group className="col-12">
                <Form.Label htmlFor="department">
                  Seleziona dipartimento
                </Form.Label>
                <select
                  id="department"
                  className="form-control"
                  value={formik.values.department}
                  name="department"
                  onChange={formik.handleChange}
                >
                  <option value={roles.agenteCompleto}>Tutti gli agenti</option>
                  <option value={roles.agenteRoydermal}>
                    Agenti Roydermal
                  </option>
                  <option value={roles.agenteRoypet}>Agenti Roypet</option>
                  <option value={roles.agenteValderma}>Agenti Valderma</option>
                  <option value={0}>Tutti i dipendenti interni</option>
                  <option value={roles.dipendente}>Dipendenti</option>
                  <option value={roles.grafico}>Grafici</option>
                  <option value={roles.magazziniere}>Magazzinieri</option>
                  <option value={roles.developer}>Developer</option>
                </select>
              </Form.Group>
            ) : null}
            <Form.Group className="col-xl-12 col-lg-12 col-sm-12">
              <Form.Label className="col-12">
                Selezionare un medico
                <Link to="/medici/#/new" style={{ float: "right" }}>
                  Aggiungi nuovo
                </Link>
              </Form.Label>
              <AsyncMediciSelect showFilters={false} name="idMedico" authToken={user.authToken} user={user} formik={formik} />
              {/* <Select
                name="idMedico"
                id="idMedico"
                placeholder="Seleziona un medico..."
                isClearable={true}
                
                classNamePrefix="react-select"
                value={medici.find((m) => m.value === formik.values.idMedico)}
                onChange={(selected) => {
                  formik.setFieldValue("idMedico", selected?.value || 0);
                }}
                options={medici.map((e) => ({
                  value: e.value,
                  label: e.label, // <-- stringa!
                  specializzazione: e.specializzazione,
                  address: e.address,
                }))}
                formatOptionLabel={(e) => (
                  <div>
                    <div>
                      <strong>{e.label}</strong>
                    </div>
                    <div style={{ fontSize: "0.90em" }}>
                      {e.specializzazione}
                    </div>
                    <div style={{ fontSize: "0.85em" }}>{e.address}</div>
                  </div>
                )}
                styles={{
                  singleValue: (provided) => ({
                    ...provided,
                    margin: 0,
                    padding: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    fontSize: "1rem",
                  }),
                }}
                components={{
                  SingleValue: ({ children }) => (
                    <div
                      style={{ padding: "8px 12px" }}
                      className="react-select__single-value"
                    >
                      {children}
                    </div>
                  ),
                }}
              />
              {formik.touched["idMedico"] && formik.errors["idMedico"] ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors["idMedico"]}
                  </div>
                </div>
              ) : null} */}
            </Form.Group>
            <Form.Group className="col-12">
              <Form.Label htmlFor="description">Note</Form.Label>
              <textarea
                id="description"
                rows="3"
                value={formik.values.description}
                className={`form-control ${getInputClasses("description")}`}
                name="description"
                placeholder="Descrizione..."
                style={{ resize: "none" }}
                {...formik.getFieldProps("description")}
              ></textarea>
              {formik.touched.description && formik.errors.description ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.description}
                  </div>
                </div>
              ) : null}
            </Form.Group>
          </Form.Row>
          <div className="col-12">
            {error ? (
              <label style={{ color: "red" }}>{errorMessage}</label>
            ) : (
              <></>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 py-4">
          <Button
            disabled={loading}
            onClick={formik.handleSubmit}
            type="submit"
          >
            {initialEvent ? "Salva" : "Crea"}
          </Button>
          <Button
            onClick={() => {
              formik.resetForm();
              setShow(false);
            }}
          >
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>{" "}
    </Form>
  );
};
